







































































import {
  Vue, Prop, Component, Watch,
} from 'vue-property-decorator';
import MainButton from '@/shared/buttons/main-button.component.vue';
import BillingDatatableUtils from './billing-datatable-utils';

@Component({
  components: {
    MainButton,
  },
})
export default class BillingColumnModal extends Vue {
  @Prop({ required: true }) showModal!: boolean;

  headerUtils: any = null

  private get modalState() {
    return this.showModal;
  }

  private set modalState(value: boolean) {
    this.$emit('updateModalState', value);
  }

  get headerOptions() {
    return this.headerUtils.headerDefault;
  }

  get headerActive() {
    return this.headerUtils.headerSelected
  }

  get headerAvailable() {
    return this.headerUtils.headerAvailable;
  }

  get headerFixed() {
    return this.headerUtils.headerFixed;
  }

  created() {
    this.headerUtils = new BillingDatatableUtils();
  }

  save() {
    let reorder: any[] = [];
    const fixed = this.headerFixed;
    const availables = this.headerAvailable.filter((h) => h.active);

    this.headerActive.forEach((h) => {
      const found = fixed.find((f) => f.value === h.value);
      if (found) {
        reorder.push(found);
        return;
      }

      const foundAvailable = availables.find((a) => a.value === h.value);
      if (foundAvailable) {
        reorder.push(foundAvailable);
      }
    });

    availables
      .filter((h) => !this.headerActive.find((hs) => hs.value === h.value))
      .forEach((h) => reorder.push(h));

    reorder = [
      ...this.headerUtils.headerFirst,
      ...reorder,
      ...this.headerUtils.headerLast,
    ];

    const reorderValues = reorder.map((h) => h.value);
    this.headerUtils.saveHeaders(reorderValues);
    this.$emit('updateColumn', reorderValues);
  }

  discardChanges() {
    this.modalState = false;
  }
}
